export class StringHelper {
  static parseQueryString(string: string): Map<string, string> {
    const hashMap: Map<string, string> = new Map()

    string.split('&').map(item => {
      const parts = item.split('=')
      hashMap.set(parts[0], parts[1])
    })

    return hashMap
  }

  static implodeQueryToString(map: Map<string, string>): string {
    const parts = []
    for (const [key, value] of map) {
      if (typeof value !== 'undefined') {
        parts.push(key + '=' + value)
      } else if (typeof key !== 'undefined') {
        parts.push(key)
      }
    }

    return parts.join('&')
  }

  static underscoreToCamel(string: string): string {
    const camel = string
      .split('_')
      .map(function(item) {
        return item.charAt(0).toUpperCase() + item.substring(1)
      })
      .join('')

    return camel.charAt(0).toLowerCase() + camel.slice(1)
  }
}
